<template>
    <div class="modal">
        <div class="background" @click="$emit('hide')"></div>
        <div class="modal-container">
            <div class="modal-header">
                <slot name="header"></slot>
            </div>
            <div class="modal-body text-center">
                <i class="fa-9x fas fa-circle-notch fa-spin"></i>
                <h1>Por favor Espere, Estamos Obteniendo la Información</h1>
            </div>
            <div class="modal-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
<style scoped lang="scss">
.background {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.5;
}

.modal-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    min-width: 300px;
    max-width: 768px;
    min-height: 500px;
    max-height: 80%;
    overflow-y: auto;
    background-color: white;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 10px;
}

.modal-header {
    display: flex;
    justify-content: center;
}

.modal-body {
    color: #000;
}

.modal-footer {
}
</style>
